/**
 * @fileoverview Based on https://www.figma.com/file/ORa7CBIooPgZj6HsEPBxNR/Design-bibliotheek-(gepubliceerd)?node-id=1303%3A6122
 * The values for Desktop klein are used
 */

import styled from 'styled-components';
import { Label } from '@amsterdam/asc-ui';
export { getSelectStyle } from '../Select/SelectStyles';

export const StyledLabel = styled(Label)`
	font-weight: 700;
`;
